import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { babyProcessingEndpoint, shipmentEndpoint } from 'src/app/utils/constants/requestUrl';

@Injectable({
  providedIn: 'root',
})
export class ShipmentService {
  constructor(private http: HttpClient) {}

  getShipment(id) {
    let params = new HttpParams();
    params = params.append('shipmentID', id);
    return this.http.get(`${environment.shipmentUrl}${shipmentEndpoint.getShipment}`, {
      params,
    });
  }

  updateShipment(data): Observable<any> {
    return this.http.post(`${environment.shipmentUrl}${shipmentEndpoint.updateShipment}`, data);
  }

  createShipment(body) {
    return this.http.post(`${environment.shipmentUrl}${shipmentEndpoint.createShipment}`, body);
  }

  getShipmentHistory(id, shipmentID) {
    let params = new HttpParams();
    params = params.append('history', 'true');
    params = params.append('shipperReference', id);
    params = params.append('shipmentID', shipmentID);
    return this.http.get(`${environment.shipmentUrl}${shipmentEndpoint.getShipment}`, {
      params,
    });
  }

  getShipmentHistoryWithReqID(id, reqId, shipmentID) {
    let params = new HttpParams();
    params = params.append('history', 'true');
    params = params.append('shipperReference', id);
    params = params.append('req_id', reqId);
    params = params.append('shipmentID', shipmentID);
    return this.http.get(`${environment.shipmentUrl}${shipmentEndpoint.getShipment}`, {
      params,
    });
  }

  updateShipmentHistory(shipperReference, req_id, confirm, shipmentID) {
    let params = new HttpParams();
    params = params.append('shipperReference', shipperReference);
    params = params.append('req_id', req_id);
    params = params.append('confirm', confirm);
    params = params.append('shipmentID', shipmentID);

    return this.http.get<any>(
      `${environment.shipmentUrl}${shipmentEndpoint.updateShipmentHistory}`,
      { params }
    );
  }

  generateLabel(shipmentId) {
    let params = new HttpParams();
    params = params.append('shipmentID', shipmentId);

    return this.http.get<string>(
      `${environment.babyprocessingUrl}${babyProcessingEndpoint.renderLabel}`,
      {
        params,
        responseType: 'text' as 'json',
        observe: 'response',
      }
    );
  }

  generateBatchLabel(shipmentIds) {
    const requestBody = {
      shipmentID: shipmentIds,
    };
    return this.http.post(
      `${environment.babyprocessingUrl}${babyProcessingEndpoint.renderBatchLabel}`,
      requestBody
    );
  }

  generatePiecesBatchLabel(pieceIDs) {
    const requestBody = {
      pieceID: pieceIDs,
    };
    return this.http.post(
      `${environment.babyprocessingUrl}${babyProcessingEndpoint.renderBatchLabel}`,
      requestBody
    );
  }

  fetchBatchLabel(shipmentIds) {
    const requestBody = {
      shipmentIDs: shipmentIds,
    };
    return this.http.post(
      `${environment.babyprocessingUrl}${babyProcessingEndpoint.fetchBatchLabel}`,
      requestBody
    );
  }
  fetchPiecesBatchLabel(pieceIDs) {
    const requestBody = {
      pieceID: pieceIDs,
    };
    return this.http.post(
      `${environment.babyprocessingUrl}${babyProcessingEndpoint.fetchBatchLabel}`,
      requestBody
    );
  }

  deleteBatchShipments(shipmentIds, confirm = false) {
    const requestBody = {
      shipmentIDs: shipmentIds,
      deleteLinked: confirm,
    };
    if (!confirm) {
      delete requestBody.deleteLinked;
    }
    return this.http.post(
      `${environment.shipmentUrl}${shipmentEndpoint.deleteShipmentBatch}`,
      requestBody
    );
  }

  getLabel(key, value) {
    let params = new HttpParams();
    params = params.append(key, value);
    return this.http.get<any>(
      `${environment.babyprocessingUrl}${babyProcessingEndpoint.fetchLabel}`,
      {
        params,
      }
    );
  }

  getInvoice(mawb) {
    let params = new HttpParams();
    params = params.append('mawb', mawb);
    params = params.append('invoice', 'true');
    return this.http.get<any>(
      `${environment.babyprocessingUrl}${babyProcessingEndpoint.fetchLabel}`,
      {
        params,
      }
    );
  }

  deleteShipmentLabel(requestBody) {
    return this.http.delete(
      `${environment.babyprocessingUrl}${babyProcessingEndpoint.deletePath}`,
      requestBody
    );
  }

  labelWindowPrint(label) {
    const byteCharacters = atob(label);
    let type = 'text/plain';
    if (byteCharacters.indexOf('%PDF') > -1) {
      type = 'application/pdf';
    }
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type });
    const blobUrl = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = blobUrl;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }

  getPieceList(id, filter: any = null) {
    const palletObj: any = {};
    palletObj.palletID = [id];
    palletObj.filter = filter;
    return this.http.post(`${environment.shipmentUrl}${shipmentEndpoint.getPiecesList}`, palletObj);
  }

  getPieceListWithShipmentId(id) {
    const shipmentObj: any = {};
    shipmentObj.shipmentID = [id];
    return this.http.post(
      `${environment.shipmentUrl}${shipmentEndpoint.getPiecesList}`,
      shipmentObj
    );
  }

  getPieceListWithMawbId(reqData) {
    return this.http.post(
      `${environment.shipmentUrl}${shipmentEndpoint.getUnlinkedPiecesList}`,
      reqData
    );
  }

  deleteShipment(id) {
    let params = new HttpParams();
    params = params.append('shipmentID', id);
    return this.http.get(`${environment.shipmentUrl}${shipmentEndpoint.deleteShipment}`, {
      params,
    });
  }

  getMawbList(data) {
    return this.http.post(`${environment.shipmentUrl}${shipmentEndpoint.getLbbxMAWBIds}`, data);
  }

  getLbbxLinkedShipments(data) {
    return this.http.post(
      `${environment.shipmentUrl}${shipmentEndpoint.lbbxLinkedShipmentList}`,
      data
    );
  }

  getShipmentLogs(data) {
    return this.http.post(`${environment.logurl}${shipmentEndpoint.babyLogs}`, data);
  }

  babyManifest(data) {
    return this.http.post(`${environment.logurl}${babyProcessingEndpoint.babyManifest}`, data);
  }

  getManifestFailedShipment() {
    return this.http.get(`${environment.shipmentUrl}${shipmentEndpoint.getManifestFailedShipment}`);
  }

  getIndividuaShiplabel(key, value) {
    let params = new HttpParams();
    params = params.append(key, value);
    params = params.append('label', 'true');
    return this.http.get<any>(
      `${environment.babyprocessingUrl}${babyProcessingEndpoint.fetchLabel}`,
      {
        params,
      }
    );
  }

  individualBabyManifest(data) {
    return this.http.post(
      `${environment.logurl}${babyProcessingEndpoint.individualBabyManifest}`,
      data
    );
  }

  getShipmentInvoice(shipmentID) {
    let params = new HttpParams();
    params = params.append('individualShipmentID', shipmentID);
    params = params.append('invoice', 'true');
    return this.http.get<any>(
      `${environment.babyprocessingUrl}${babyProcessingEndpoint.fetchLabel}`,
      {
        params,
      }
    );
  }

  getShipmentUploadList(requestBody) {
    return this.http.post(
      `${environment.shipmentUrl}${shipmentEndpoint.viewBabyFileData}`,
      requestBody
    );
  }

  deleteUploadCI(requestBody) {
    return this.http.delete(
      `${environment.shipmentUrl}${shipmentEndpoint.deleteUploadedCI}`,
      requestBody
    );
  }
}
